import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Stack, Typography, } from '@mui/material';
import { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import { Filter } from 'mdi-material-ui';
import groupItems from '../utils/groupBy';
import Rows from './Rows';
import GroupedRows from './GroupedRows';
import IsLoading from './Isloading';
import NoResultsFound from './NoResultsFound';
const DynamicTable = ({ columns, rows, selectable = false, stickyHeader = false, onRowSelectionChange = (newValues) => { }, size, getRowId = (row) => row._id, paginationProps, groupBy, isLoading, actions, closePopover = false }) => {
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [indeterminate, setIndeterminate] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isPopoverOpen, setPopoverOpen] = useState(closePopover);
    const [FilterComponent, setFilterComponent] = useState();
    useEffect(() => { setPopoverOpen(closePopover); }, [closePopover]);
    const open = !isPopoverOpen && Boolean(anchorEl);
    const onSelectAllChange = (e) => {
        const isChecked = e.target.checked;
        let newSelectedIds = new Set([...selectedIds]);
        if (isChecked) {
            newSelectedIds = new Set([
                ...newSelectedIds,
                ...rows.map((row) => getRowId(row)),
            ]);
        }
        else {
            rows.forEach((row) => {
                newSelectedIds.delete(getRowId(row));
            });
        }
        setSelectedIds([...newSelectedIds]);
        setSelectAll(isChecked);
        onRowSelectionChange([...newSelectedIds]);
    };
    const onCheckboxChange = (checked, value) => {
        let newSelectedIds = new Set(selectedIds);
        const rowId = getRowId(value);
        if (checked) {
            newSelectedIds.add(rowId);
        }
        else {
            newSelectedIds.delete(rowId);
        }
        setSelectedIds([...newSelectedIds]);
        onRowSelectionChange([...newSelectedIds]);
    };
    useEffect(() => {
        const selection = new Set(rows.map((row) => selectedIds.includes(getRowId(row))));
        if (selection.size > 1)
            setIndeterminate(true);
        else {
            setIndeterminate(false);
            setSelectAll(selection.has(true));
        }
    }, [rows, selectedIds]);
    let groupedRows = {};
    if (groupBy)
        groupedRows = groupItems(rows, groupBy.key);
    const handleHeaderSelect = (label, checked) => {
        const selectedItems = groupedRows[label];
        if (checked) {
            let newSelectedIds = new Set([...selectedIds]);
            let updatedIds = [
                ...newSelectedIds,
                ...new Set(selectedItems.map((i) => i._id)),
            ];
            setSelectedIds(updatedIds);
            onRowSelectionChange(updatedIds);
            return;
        }
        const idsToRemove = groupedRows[label].map((i) => i._id);
        let updatedIds = selectedIds.filter((i) => !idsToRemove.includes(i));
        setSelectedIds(updatedIds);
        onRowSelectionChange(updatedIds);
        return;
    };
    return (_jsxs(_Fragment, { children: [selectedIds.length > 0 && (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "space-between", sx: { backgroundColor: '#F5F4FC', p: '16px' } }, { children: [_jsxs(Typography, Object.assign({ variant: "h4" }, { children: [selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length, " item selected"] })), _jsx(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 4 }, { children: actions === null || actions === void 0 ? void 0 : actions.map((i) => i.render({ selectedIds })) }))] }))), _jsxs(TableContainer, Object.assign({ component: Paper }, { children: [_jsxs(Table, Object.assign({ stickyHeader: stickyHeader, size: size }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, Object.assign({ sx: { height: '54px' } }, { children: [selectable && (_jsx(TableCell, { children: _jsx(Checkbox, { onChange: onSelectAllChange, indeterminate: indeterminate, checked: selectAll }) })), columns.map((column, idx) => (_jsxs(TableCell, Object.assign({ sx: {
                                                whiteSpace: 'nowrap',
                                                textAlign: 'center',
                                                cursor: column.FilterComponent ? 'pointer' : 'auto',
                                            }, onClick: (e) => {
                                                if (column.FilterComponent) {
                                                    setFilterComponent(column.FilterComponent);
                                                    setAnchorEl(e.currentTarget);
                                                    setPopoverOpen(false);
                                                }
                                            } }, { children: [column.heading, column.FilterComponent ? (_jsx(Filter, { sx: { height: '15px' } })) : ('')] }), idx)))] })) }), _jsx(TableBody, { children: isLoading ? (_jsx(IsLoading, { rowLength: rows.length, colLength: columns.length })) : !rows.length ? (_jsx(NoResultsFound, { colLength: columns.length })) : !groupBy ? (_jsx(Rows, { columns: columns, getRowId: getRowId, onCheckboxChange: onCheckboxChange, rows: rows, selectable: selectable, selectedIds: selectedIds })) : (_jsx(GroupedRows, { columns: columns, groupedRows: groupedRows, render: groupBy.render, selectable: selectable, onCheckboxChange: onCheckboxChange, selectedIds: selectedIds, getRowId: getRowId, onHeaderSelect: handleHeaderSelect })) })] })), anchorEl && (_jsx(Popover, Object.assign({ open: open, anchorEl: anchorEl, onClose: () => setAnchorEl(null), PaperProps: {
                            sx: { boxShadow: 1 },
                        }, anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        } }, { children: FilterComponent })))] })), paginationProps && (_jsx(TablePagination, Object.assign({}, paginationProps, { component: 'div' })))] }));
};
export default DynamicTable;
